'use client';

// Decisão de produto (10/06/2026): refresh na página ZERA a conversa do chat
// público. Por isso o id do visitante vive só em memória (por carregamento de
// página), sem localStorage: cada reload gera uma conversa nova no servidor.
let visitorId: string | null = null;

/** Identidade do visitante anônimo (chat público). Efêmera: dura só até o reload. */
export function getOrCreateVisitorId(): string {
  if (!visitorId) visitorId = crypto.randomUUID();
  return visitorId;
}
